// eslint-disable-next-line
export const Clone = (object: unknown): any => {
    return JSON.parse(JSON.stringify(object));
};
